import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquarePlaceholderDashed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-placeholder-dashed"} maskId="square-filled-radius-0-stroke-1-IconSquarePlaceholderDashed"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H6V4H4V6H3V3ZM10 3H14V4H10V3ZM17.875 3H21V6.125H20V4H17.875V3ZM4 10V14H3V10H4ZM21 10V14H20V10H21ZM4 18V20H6V21H3V18H4ZM21 18V21H18V20H20V18H21ZM10 20H14V21H10V20Z" fill="currentColor"/><path d="M6 6H18V18H6V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquarePlaceholderDashed;
